import AGENCY_API_V1 from 'api/agency/v1'
import { startSubmit, SubmissionError } from 'redux-form'
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { cancellableCall } from 'store/saga-utils/cancellableCall.saga'
import { confirmSaga } from 'store/saga-utils/confirm.saga'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'

function* fetch({ payload }) {
  const { pagination, data: currentData } = yield select(
    (state) => state['agency/requests'],
  )

  yield put({
    type: 'AGENCY/REQUESTS_TOGGLE_LOADING',
    payload: { loading: true },
  })

  try {
    const { response, error, canceled } = yield cancellableCall(
      AGENCY_API_V1.fetchRequests,
      {
        params: payload.params,
      },
      arguments,
    )

    if (canceled) return

    if (error) {
      throw error
    }

    const {
      data,
      pagination: { total },
    } = response

    yield put({
      type: 'AGENCY/REQUESTS_SET_DATA',
      payload: {
        data: currentData.concat(data),
        pagination: {
          ...pagination,
          total,
        },
      },
    })
  } catch (error) {
    yield put({ type: 'AGENCY/REQUESTS_LOAD_DATA_FAILED' })
    console.logXHR(error)
  } finally {
    yield put({
      type: 'AGENCY/REQUESTS_TOGGLE_LOADING',
      payload: { loading: false },
    })
  }
}

function* requestAdd({
  payload: { data, formName },
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))

    const { error } = yield call(AGENCY_API_V1.addRequest, { data })

    if (error) {
      throw error
    }

    resolve()
  } catch (e) {
    const { form, fields } = extractErrors(e.errors)

    fields && reject(new SubmissionError(fields))

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }
  }
}

function* deleteRequest({ payload }) {
  try {
    yield put({
      type: 'AGENCY/REQUEST_UPDATE',
      payload: { id: payload.id, update: { processing: true } },
    })

    const response = yield call(AGENCY_API_V1.deleteRequest, { id: payload.id })

    if (response.error) {
      throw new Error('request_delete_failed')
    }

    yield put({ type: 'AGENCY/REQUESTS_LIST_REMOVE_ITEM', payload: payload })
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.remove_failed',
      }),
    )

    yield put({
      type: 'AGENCY/REQUEST_UPDATE',
      payload: { id: payload.id, update: { processingFailed: true } },
    })
    console.logXHR(error)
  }
}

function* confirmDeleteRequest({ payload }) {
  try {
    const [confirmed, UUID] = yield call(confirmSaga, {
      modalType: 'confirmation',
      ...payload,
    })

    if (confirmed) {
      yield put({ type: 'MODAL/HIDE', payload: { UUID } })
      yield put({
        type: 'AGENCY/REQUEST_DELETE',
        payload: { id: payload.id },
      })
    } else {
      yield put({ type: 'MODAL/HIDE', payload: { UUID } })
    }
  } catch (error) {
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest('AGENCY/REQUESTS_FETCH', fetch)
  yield takeLatest(
    'AGENCY/REQUESTS_DELETE_REQUEST_CONFIRM',
    confirmDeleteRequest,
  )
  yield takeEvery('AGENCY/REQUEST_DELETE', deleteRequest)
  yield takeLatest('AGENCY/REQUEST_ADD', requestAdd)
}
